import { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import id from "date-fns/locale/id";

import { Icon } from "@iconify-icon/react/dist/iconify.js";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

registerLocale("id", id);
setDefaultLocale("id");

const DynamicForm = ({
    logo,
    title,
    subtitle,
    fields = [],
    onSubmit,
    button,
    customDescription,
    labels = true,
    footer = true,
    helpButton,
    className,
}) => {
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
        setValue,
        trigger,
    } = useForm();
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (Array.isArray(fields)) {
            fields.forEach((field) => {
                if (
                    field.value !== undefined &&
                    field.value !== null &&
                    field.value !== ""
                ) {
                    setValue(field.name, field.value);
                    trigger(field.name);
                }
            });
        }
    }, [fields, setValue, trigger]);

    const onFormSubmit = (data) => {
        // console.log(data);
        if (onSubmit) onSubmit(data);
    };

    const currentYear = new Date().getFullYear();

    return (
        <div
            className={`card-basic rounded-md items-stretch flex-col m-2 ${className}`}
        >
            {/* Header */}
            <div
                className={`flex flex-col p-2 justify-center items-center ${
                    (logo && "mt-6") || ""
                }`}
            >
                {logo && (
                    <img
                        src={logo}
                        alt="logo"
                        className="self-center size-24"
                    />
                )}

                {title && (
                    <h2 className="mt-4 font-medium text-2xl text-center">
                        {title}
                    </h2>
                )}
                {subtitle && (
                    <p className="mt-1 font-normal text-lg text-center">
                        {subtitle}
                    </p>
                )}
                {customDescription && (
                    <h4 className="mt-1 font-normal text-center">
                        {customDescription}
                    </h4>
                )}
            </div>
            <form onSubmit={handleSubmit(onFormSubmit)} className="">
                {Array.isArray(fields) &&
                    fields.map((field) => (
                        <div key={field.name} className="mt-4 md:mt-6 w-full">
                            {labels && field.label && (
                                <label className="block pb-1 text-gray-700">
                                    {field.label}
                                </label>
                            )}
                            {field.type === "textarea" ? (
                                <textarea
                                    defaultValue={field.value || ""}
                                    {...register(field.name, {
                                        required: field.required,
                                        ...(field.validation || {}),
                                    })}
                                    disabled={field.disabled}
                                    rows={field.textAreaRows}
                                    className={` w-full p-2 mb-1 border rounded-sm shadow-xs hover:ring-1 hover:ring-primary focus:outline-hidden focus:ring-2 focus:ring-primary transition-all duration-300 ${
                                        field.disabled
                                            ? "bg-gray-200 cursor-not-allowed"
                                            : "bg-white"
                                    }`}
                                />
                            ) : field.type === "checkbox" ? (
                                <div className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        defaultChecked={field.value || false}
                                        {...register(field.name)}
                                        disabled={field.disabled}
                                        className={` rounded-md border-gray-300 shadow-xs focus:ring-2 focus:ring-secondary ${
                                            field.disabled
                                                ? "bg-gray-200 cursor-not-allowed"
                                                : "bg-white"
                                        }`}
                                    />
                                    <span>{field.label}</span>
                                </div>
                            ) : field.type === "select" ? (
                                <select
                                    defaultValue={field.value || ""}
                                    {...register(field.name, {
                                        required: field.required,
                                        ...(field.validation || {}),
                                    })}
                                    disabled={field.disabled}
                                    className={` w-full p-2 border rounded-md shadow-xs hover:ring-primary focus:outline-hidden focus:ring-2 focus:ring-primary transition-all duration-300 ${
                                        field.disabled
                                            ? "bg-gray-200 cursor-not-allowed"
                                            : "bg-white"
                                    }`}
                                >
                                    {field.options.map((option, index) => (
                                        <option
                                            key={index}
                                            value={option.value}
                                            disabled={option.disabled}
                                        >
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            ) : field.type === "year" ? (
                                <input
                                    type="number"
                                    defaultValue={field.value || ""}
                                    placeholder={field.placeholder || "YYYY"}
                                    {...register(field.name, {
                                        required: field.required,
                                        validate: (value) =>
                                            (value >= 2018 &&
                                                value <= currentYear + 1) ||
                                            "Tahun tidak valid!",
                                    })}
                                    disabled={field.disabled}
                                    min="1900"
                                    max={currentYear + 1}
                                    step="1"
                                    className={` w-full p-2 mb-1 border rounded-sm shadow-xs hover:ring-1 hover:ring-primary focus:outline-hidden focus:ring-2 focus:ring-primary transition-all duration-300 ${
                                        field.disabled
                                            ? "bg-gray-200 cursor-not-allowed"
                                            : "bg-white"
                                    }`}
                                />
                            ) : field.type === "phone" ? (
                                <div className="relative flex items-center">
                                    <span className="left-0 absolute px-2 border-gray-300 border-r text-gray-500">
                                        +62
                                    </span>
                                    <input
                                        type="tel"
                                        defaultValue={field.value || ""}
                                        placeholder={
                                            field.placeholder || "8123456789"
                                        }
                                        {...register(field.name, {
                                            required: field.required,
                                            pattern: {
                                                value: /^8[1-9][0-9]{6,12}$/,
                                                message:
                                                    "Nomor tidak valid! (contoh valid: 8123456789)",
                                            },
                                            ...(field.validation || {}),
                                        })}
                                        disabled={field.disabled}
                                        className={` w-full pl-12 p-2 mb-1 border rounded-sm shadow-xs hover:ring-1 hover:ring-primary focus:outline-hidden focus:ring-2 focus:ring-primary transition-all duration-300 ${
                                            field.disabled
                                                ? "bg-gray-200 cursor-not-allowed"
                                                : "bg-white"
                                        }`}
                                    />
                                </div>
                            ) : field.type === "radio" ? (
                                <div className="flex gap-4">
                                    {field.options.map((option, index) => (
                                        <div
                                            key={index}
                                            className="flex items-center space-x-2"
                                        >
                                            <input
                                                type="radio"
                                                value={option.value}
                                                defaultChecked={
                                                    field.value === option.value
                                                }
                                                {...register(field.name, {
                                                    required: field.required,
                                                    ...(field.validation || {}),
                                                })}
                                                disabled={
                                                    field.disabled ||
                                                    option.disabled
                                                }
                                                className={` border-gray-300 shadow-xs focus:ring-2 focus:ring-primary 
                                            ${
                                                field.disabled
                                                    ? "bg-gray-200 cursor-not-allowed"
                                                    : "bg-white"
                                            }`}
                                            />
                                            <label>{option.label}</label>
                                        </div>
                                    ))}
                                </div>
                            ) : field.type === "number" ? (
                                <input
                                    type="number"
                                    defaultValue={field.value || ""}
                                    placeholder={field.placeholder || ""}
                                    min={field.min}
                                    max={field.max}
                                    step={field.step || 1}
                                    {...register(field.name, {
                                        required: field.required,
                                        ...(field.min && {
                                            min: {
                                                value: field.min,
                                                message: `Minimum value is ${field.min}`,
                                            },
                                        }),
                                        ...(field.max && {
                                            max: {
                                                value: field.max,
                                                message: `Maximum value is ${field.max}`,
                                            },
                                        }),
                                        ...(field.validation || {}),
                                    })}
                                    disabled={field.disabled}
                                    className={` w-full p-2 mb-1 border rounded-sm shadow-xs hover:ring-1 hover:ring-primary 
                                focus:outline-hidden focus:ring-2 focus:ring-primary transition-all duration-300 
                                ${
                                    field.disabled
                                        ? "bg-gray-200 cursor-not-allowed"
                                        : ""
                                }`}
                                />
                            ) : field.type === "date" ? (
                                <Controller
                                    name={field.name}
                                    control={control}
                                    defaultValue={field.value || null}
                                    rules={{ required: field.required }}
                                    render={({
                                        field: { onChange, value },
                                    }) => (
                                        <DatePicker
                                            selected={value}
                                            onChange={onChange}
                                            disabled={field.disabled}
                                            className={`w-full p-2 border rounded-md shadow-xs hover:ring-1 hover:ring-primary focus:outline-hidden focus:ring-2 focus:ring-primary transition-all duration-300 ${
                                                field.disabled
                                                    ? "bg-gray-200 cursor-not-allowed"
                                                    : "bg-white"
                                            }`}
                                            dateFormat="dd/MM/yyyy"
                                            wrapperClassName="w-full"
                                            showYearDropdown
                                            showMonthDropdown
                                        />
                                    )}
                                />
                            ) : field.type === "multi-input" ? (
                                <Controller
                                    name={field.name}
                                    control={control}
                                    defaultValue={field.value || [""]}
                                    render={({
                                        field: { onChange, value = [""] },
                                    }) => (
                                        <div className="space-y-2">
                                            {value.map((item, index) => (
                                                <div
                                                    key={index}
                                                    className="flex gap-2"
                                                >
                                                    {field.inputType ===
                                                    "textarea" ? (
                                                        <textarea
                                                            value={item}
                                                            rows={
                                                                field.textAreaRows ||
                                                                2
                                                            }
                                                            onChange={(e) => {
                                                                const newValues =
                                                                    [...value];
                                                                newValues[
                                                                    index
                                                                ] =
                                                                    e.target.value;
                                                                onChange(
                                                                    newValues
                                                                );
                                                            }}
                                                            placeholder={
                                                                field.placeholder ||
                                                                ""
                                                            }
                                                            className={`w-full p-2 border rounded-sm shadow-xs hover:ring-1 hover:ring-primary 
                                                            focus:outline-hidden focus:ring-2 focus:ring-primary transition-all duration-300 ${
                                                                field.disabled
                                                                    ? "bg-gray-200 cursor-not-allowed"
                                                                    : ""
                                                            }`}
                                                        />
                                                    ) : (
                                                        <input
                                                            type={
                                                                field.inputType ||
                                                                "text"
                                                            }
                                                            value={item}
                                                            onChange={(e) => {
                                                                const newValues =
                                                                    [...value];
                                                                newValues[
                                                                    index
                                                                ] =
                                                                    field.inputType ===
                                                                    "number"
                                                                        ? e
                                                                              .target
                                                                              .value ===
                                                                          ""
                                                                            ? ""
                                                                            : Number(
                                                                                  e
                                                                                      .target
                                                                                      .value
                                                                              )
                                                                        : e
                                                                              .target
                                                                              .value;
                                                                onChange(
                                                                    newValues
                                                                );
                                                            }}
                                                            min={
                                                                field.inputType ===
                                                                "number"
                                                                    ? field.min ||
                                                                      0
                                                                    : undefined
                                                            }
                                                            max={
                                                                field.inputType ===
                                                                "number"
                                                                    ? field.max
                                                                    : undefined
                                                            }
                                                            step={
                                                                field.inputType ===
                                                                "number"
                                                                    ? field.step ||
                                                                      1
                                                                    : undefined
                                                            }
                                                            placeholder={
                                                                field.placeholder ||
                                                                ""
                                                            }
                                                            className={`w-full p-2 border rounded-sm shadow-xs hover:ring-1 hover:ring-primary 
                                                            focus:outline-hidden focus:ring-2 focus:ring-primary transition-all duration-300 ${
                                                                field.disabled
                                                                    ? "bg-gray-200 cursor-not-allowed"
                                                                    : ""
                                                            }`}
                                                        />
                                                    )}
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            const newValues =
                                                                value.filter(
                                                                    (_, i) =>
                                                                        i !==
                                                                        index
                                                                );
                                                            onChange(
                                                                newValues.length
                                                                    ? newValues
                                                                    : [""]
                                                            );
                                                        }}
                                                        className="hover:bg-danger/10 px-2 pt-1 rounded-full text-danger transition-colors"
                                                    >
                                                        <Icon
                                                            icon="mdi:delete"
                                                            width="20"
                                                            height="20"
                                                        />
                                                    </button>
                                                </div>
                                            ))}
                                            <button
                                                type="button"
                                                onClick={() =>
                                                    onChange([...value, ""])
                                                }
                                                className="flex items-center gap-1 text-primary hover:text-primary-dark text-sm"
                                            >
                                                <Icon
                                                    icon="mdi:plus"
                                                    width="20"
                                                    height="20"
                                                />
                                                Tambah
                                            </button>
                                        </div>
                                    )}
                                />
                            ) : (
                                <div className="relative">
                                    <input
                                        type={
                                            field.type === "password" &&
                                            showPassword
                                                ? "text"
                                                : field.type
                                        }
                                        defaultValue={field.value || ""}
                                        placeholder={field.placeholder || ""}
                                        {...register(field.name, {
                                            required: field.required,
                                            ...(field.validation || {}),
                                        })}
                                        disabled={field.disabled}
                                        className={` w-full p-2 mb-1 border rounded-sm shadow-xs hover:ring-1 hover:ring-primary focus:outline-hidden focus:ring-2 focus:ring-primary transition-all duration-300 ${
                                            field.disabled
                                                ? "bg-gray-200 cursor-not-allowed"
                                                : ""
                                        }`}
                                    />
                                    {field.type === "password" && (
                                        <button
                                            type="button"
                                            onClick={() =>
                                                setShowPassword(!showPassword)
                                            }
                                            className="right-0 absolute inset-y-0 flex items-center px-3 text-sm leading-5"
                                        >
                                            {!showPassword ? (
                                                <Icon
                                                    icon="eva:eye-outline"
                                                    width="24"
                                                    height="24"
                                                    className="text-gray-400 hover:text-black transition-all duration-200"
                                                />
                                            ) : (
                                                <Icon
                                                    icon="eva:eye-off-outline"
                                                    width="24"
                                                    height="24"
                                                    className="text-gray-400 hover:text-black transition-all duration-200"
                                                />
                                            )}
                                        </button>
                                    )}
                                </div>
                            )}
                            {errors[field.name] && (
                                <span className="text-danger text-sm">
                                    {errors[field.name].message ||
                                        `${field.label} tidak boleh kosong!`}
                                </span>
                            )}
                        </div>
                    ))}
                {helpButton}
                {button}
                {footer && (
                    <div className="mt-6 p-4 border-t-[0.5px] font-light text-xs text-center">
                        <p>©PPG Cikampek All Right Reserved {currentYear}</p>
                        {/* <p>© <a href="http://localhost:5173/" className='active:text-primary underline'>PPG Cikampek</a> All Right Reserved {currentYear}</p> */}
                    </div>
                )}
            </form>
        </div>
    );
};

export default DynamicForm;
